export enum IPLevels {
  undefined = 0,
  ip1 = 1,
  'ip1+' = 2,
  ip2 = 3,
  'ip2+' = 4,
  ip3 = 5,
  ip4 = 6,
}
